import styled from "styled-components";

export const Container = styled.div`
   width: 100%;
   background-color: white;
   box-shadow: #fbe77724 0px 0px 20px;
   display: flex;
   align-items: center;
   border-radius: 10px;
   justify-content: space-between;
   
   img{
    width: 200px;
   }
   .pontos{
    height: -webkit-fill-available;
    vertical-align: middle;
    display: table;
    width: 170px;
    background-color: #19a91b;
    text-align: center;
    color: white;
    display: flex;
    justify-content: center;
    font-weight: bold;
    align-items: center;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
   }
   .divide{
    height: -webkit-fill-available;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 1px;
    background-color: #d2d0c1;
   }

   @media only screen and (max-width: 1080px) {
      flex-direction: column;
      
      .divide{
         margin-bottom: 15px;
         width: 100%;
         height: 2px;
      }

      .contentP{
         margin-bottom: 15px;
      }

      .divideFirst{
         display: none;
      }
      .pontos{
         border-radius: 0px;
         border-bottom-left-radius: 10px;
         border-bottom-right-radius: 10px;
         width: 100%;
         margin-right: 0px;
         padding: 10px;
      }
   }
`;

